import { localized, msg } from "@lit/localize";
import { BaseExtraButton, type Params } from "@whilecat/core/editors/buttons/base-extra-button.js";
import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

const noop = () => {};

@localized()
@customElement("reset-button")
export class ResetButton extends BaseExtraButton {
    static styles = [
        super.styles,
        css`
          .extra-button-toggled {
            animation: toggled ease-in-out 0.8s, rotate ease-in 0.8s;
            animation-iteration-count: 1;
          }

          @keyframes rotate {
            0% {
              transform: rotate(0deg);
            }
            50% {
              transform: rotate(-1440deg);
              animation-timing-function: ease-out;
            }
            100% {
              transform: rotate(-1800deg);
              animation-timing-function: ease-in;
            }
          }
        `,
    ];

    @property() resetButtonCallBack: () => void = noop;

    static html({
        onclick = noop,
        visible = true,
        disabled = false,
        toggled = false,
    }: Params & { onclick: () => void }) {
        return html`<reset-button
            @click=${onclick}
            .visible=${visible}
            .disabled=${disabled}
            .toggled=${toggled}>
        </reset-button>`;
    }

    constructor() {
        super("arrow-counterclockwise", "tropical-storm", msg("Reset Code"));
    }

    onClicked() {
        super.playToggleAnimation();
        this.resetButtonCallBack();
    }
}
